import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';

import { default as ResourcePeriodPicker, DataUrlProps  } from './ResourcePeriodPicker'
import { FocusedInputShape } from 'react-dates';

import { StartEnd, DisabledProps, PrefixProps } from './PeriodPicker'

type Props = StartEnd & PrefixProps & {
  room_id: number,
  onDatesChange: (arg: { startDate: Moment | null, endDate: Moment | null }) => void,
  onFocusChange: (fi: FocusedInputShape) => void
  focusedInput: FocusedInputShape
  numberOfMonths?: number
  close: () => void
}

export default class AdvertPeriodPicker extends React.Component<Props> {

  constructor(props, context) {
    super(props, context)
  }

  render() {
    return (
      <ResourcePeriodPicker
        {...this.props}
        data_url={this.props.room_id ? `/rooms/${this.props.room_id}/datepicker_data` : null}
        disabled={!this.props.room_id}
      />
    )
  }
}